import { useState, useEffect } from 'react';
import { ActionButton, TooltipTrigger, Tooltip } from '@adobe/react-spectrum';
import React from 'react';
function LinkedActionButton(props) {
    const { isDarkMode, isAlreadyLinked, linkEvent } = props;
    const [isLinked, updateLink] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    
    // Icon color logic: prioritize linked state, then hover state, then default
    const getFillColor = () => {
        if (isLinked) return '#fff'; // white when linked
        if (isHovered && isDarkMode) return '#464646'; // dark when hovering in dark mode
        return isDarkMode ? '#fff' : '#464646'; // normal theme colors
    };
    
    const fillColor = getFillColor();
    const selectedBg = '#1473e6'; // blue color for both light and dark modes when linked
    const defaultBg = 'transparent';
    const hoverBg = isDarkMode ? '#e6e6e6' : '#a6a8a3'; // whitish for dark mode, grey for light mode
    const onToggle = () => {
        if (!isLinked) {
            updateLink(true);
            linkEvent(true);
        }
    }
    useEffect(() => {
        updateLink(isAlreadyLinked)
    }, [isAlreadyLinked]);

    const getBackgroundColor = () => {
        if (isLinked) return selectedBg;
        if (isHovered) return hoverBg;
        return defaultBg;
    };

    return (
        <div 
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{ display: 'inline-block' }}
        >
            <TooltipTrigger crossOffset={10} delay={100} placement="right">
                <ActionButton
                    onPress={onToggle}
                    aria-label={isLinked ? 'Employee is linked' : 'Link employee'}
                    UNSAFE_style={{
                        width: '22px',
                        height: '22px',
                        minWidth: '22px',
                        minHeight: '22px',
                        borderRadius: '50%',
                        padding: 0,
                        lineHeight: 1,
                        marginLeft: '0.5em',
                        verticalAlign: 'middle',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: getBackgroundColor(),
                        transition: 'background-color 0.2s ease-in-out',
                        flexShrink: 0,
                        border: 'none',
                        outline: 'none',
                    }}
                >
                <svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 18 18" width="12">
                    <defs>
                        <style>
                            {`.link-action-fill {
              fill: ${fillColor};
            }`}
                        </style>
                    </defs>
                    <rect fill="none" opacity="0" width="18" height="18" />
                    <path
                        className="link-action-fill"
                        d="M15.85,2.15a3.588,3.588,0,0,0-5.074,0c-.1925.193-2.132,2.111-2.6755,2.6545A4.15349,4.15349,0,0,1,9.972,5.108c.2595-.26,1.784-1.763,1.8915-1.8705a2.05061,2.05061,0,1,1,2.9,2.9L11.204,9.695a2.30853,2.30853,0,0,1-1.686.65,1.97648,1.97648,0,0,1-1.35-.5545,2.07708,2.07708,0,0,1-.6205-.813,1.03342,1.03342,0,0,0-.214.159l-.8175.856a3.57187,3.57187,0,0,0,.613.8365,3.92429,3.92429,0,0,0,5.3385-.219L15.85,7.226a3.587,3.587,0,0,0-.00322-5.07278Z"
                    />
                    <path
                        className="link-action-fill"
                        d="M7.963,12.912c-.26.26-1.75,1.7735-1.8565,1.881a2.05061,2.05061,0,0,1-2.9-2.9L6.8,8.3a2.29,2.29,0,0,1,1.683-.646,2.1,2.1,0,0,1,1.892,1.391,1.03342,1.03342,0,0,0-.214-.159l.867-.8605a3.58269,3.58269,0,0,0-.613-.8365,3.6555,3.6555,0,0,0-5.13.024L2.1195,10.806a3.588,3.588,0,1,0,5.074,5.0745c.193-.193,2.097-2.1215,2.6405-2.665A4.15006,4.15006,0,0,1,7.963,12.912Z"
                    />
                </svg>
                </ActionButton>
                <Tooltip>{isLinked ? "Select another Employee to unlink" : "Link this Employee"}</Tooltip>
            </TooltipTrigger>
        </div>
    );
}

export default LinkedActionButton;
